import { AnnotatorTool, Type } from "./annotator-tool";

//@annotatorTool
export class Comment implements AnnotatorTool{
    code = Type.comment;
    get quickAction(){
      return {
        html : getQuickCommentHtml('ann-comment', this.disabled, this.tooltip),
        id : 'ann-comment'
      }
    };
    attachComment = true;
    className = 'annotator-comment';
    showTrash = true;
    legantoAnnotator = true;
    disabled = false;
    tooltip = 'design.tool.comment';

    constructor(){}
}

export function getQuickCommentHtml(id, isDisabled, tooltip){
  return `<div class="flex-basis">
<button id="${id}" ${(isDisabled ? 'disabled' : '')} title="${tooltip}" class="btn btn-clear comment" tabindex="0">
    <i class="fa fa-comment" aria-hidden="true"></i>
</button>
</div>`;
}